/*
    This class manages the loading and reveal animation of images to prevent FOUC.
    If the image is ready, the animation triggers immediately; otherwise, it waits until the image loads.
    Usage:
    <div class="image-wrapper">
        <img src="..." alt="">
    </div>

    Warning: HTML may still load before CSS and JS, briefly displaying images before fading in.
    To fully prevent FOUC, use inline styles.
    For instance:
    <div class="image-wrapper">
        <img src="..." alt="" style="opacity: 0">
    </div>
*/

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ImageWrapper {
    static key = 'ImageWrapper';

    constructor(el) {
        this.el = el;

        if (!this.el) {
            console.error('[initImage] Container element is required');
            return;
        }

        const image = this.el.querySelector('img');
        if (!image) {
            console.error('[initImage] No image found within container:', this.el);
            return;
        }

        // Set initial state right away
        gsap.set(image, { opacity: 0, scale: 1.15 });

        // Define the timeline that will be played if or once the image is loaded
        const tl = gsap.timeline({
            paused: true,
            scrollTrigger: {
                trigger: this.el,
                start: 'top 92%',
            },
        });
        tl.to(
            image,
            {
                opacity: 1,
                scale: 1,
                duration: 0.6,
                ease: 'power2.inOut',
                //delay: 10,
            },
            0
        );

        // Initially disable the scrolltrigger to prevent activation before the image loads.
        tl.scrollTrigger.disable();

        const handleImageLoad = () => {
            image.removeEventListener('load', handleImageLoad);
            image.removeEventListener('error', handleImageLoad);

            tl.scrollTrigger.enable();
        };

        if (image.complete) {
            tl.scrollTrigger.enable();
        } else {
            image.addEventListener('load', handleImageLoad);
            image.addEventListener('error', handleImageLoad);
        }
    }
}
